<script lang='ts'>
    import type {CriteriaType} from '../store/types';
    import serviceStore from '../store/service';
    import {isDefinedNotNullNotEmpty} from '../helpers/common';
    import {getUrlParam} from '../helpers/url';
    import lang from '../lang/language';
    import {onMount} from 'svelte';
    import Button from "./controls/Button.svelte";

    let name = getUrlParam('name') || '';
    let type = getUrlParam('type');
    let price = getUrlParam('price') || '';

    let criteria: CriteriaType = {Id: null};


    $:{
        //reset
        criteria = {Id: null};

        isDefinedNotNullNotEmpty(type) ? criteria.IndustryCategoryGroups = [parseInt(type)] : '';
        name ? criteria.Name = name : '';

        if (price) {
            const prices = price.split('-');
            let bookability: any = {RateRange: {}};

            parseInt(prices[0]) > 0 ? bookability.RateRange.Min = parseInt(prices[0]) : '';
            parseInt(prices[1]) > 0 ? bookability.RateRange.Max = parseInt(prices[1]) : '';

            criteria.Bookability = bookability;
        }


    }

    onMount(search);

    function search() {
        serviceStore.search(criteria);
    }

    function getSubtitle() {
        let subtitle = '';
        switch (type) {
            case '0':
                subtitle = lang.search_accommodation;
                break;
            case '1':
                subtitle = lang.search_activity;
                break;
            case '2':
                subtitle = lang.search_restaurant;
                break;
            case '3':
                subtitle = lang.search_product;
                break;
            default:
                subtitle = lang.search_everything;
                break;
        }
        return subtitle;
    }

</script>

<div class='search-wrapper'>
<!--    <h3 class='subsubtitle emoji'>{@html lang.search_subsubtitle}</h3>-->
    <div class='form-wrapper'>
        <div class='row'>
            <div class='input-wrapper icon keyword'>
                <input bind:value={name} class='input-field' type='text'
                       placeholder={lang.search_keyword}>
            </div>
        </div>
        <div class='row' style={`display: ${getUrlParam('type') ? 'none' : 'block'}`}>
            <div class='input-wrapper icon category select'>
                <select class='input-field' type='text'
                        placeholder='Choose Category' bind:value={type}>
                    <option value=''>{lang.search_all_categories}</option>
                    <option value='0'>{lang.accommodation}</option>
                    <option value='1'>{lang.activity}</option>
                    <option value='2'>{lang.restaurant}</option>
                    <option value='3'>{lang.produce}</option>
                </select>
            </div>
        </div>
        <div class='row' style="display: block">
            <div class='input-wrapper icon price select'>
                <select class='input-field' type='text'
                        placeholder='Choose price' bind:value={price}>
                    <option value=''>{lang.search_price_range}</option>
                    <option value='1-9999'>&lt; ¥9.999</option>
                    <option value='10000-14999'>¥10.000 - ¥14.999</option>
                    <option value='15000-19999'>¥15.000 - ¥19.999</option>
                    <option value='20000-'>¥20.000 +</option>
                </select>
            </div>
        </div>
        <div class='row text-center'>
            <Button primary onClick={search} classList={['search-button']}>{lang.search_button}</Button>
        </div>
    </div>
</div>

<style>
    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }


    .subtitle, .subsubtitle {
        text-align: center;
        font-family: inherit;
    }

    .title {
        font-size: 30px;
        margin-bottom: 20px;
        width: 100%;
        text-align: center;
        color:  grey;
    }

    .subtitle {
        background-color: transparent;
        font-weight: bold;
        padding: 10px;
        letter-spacing: 2px;
    }

    .subsubtitle {
        padding: 15px 5px;
    }

    .search-wrapper {
        text-align: center;

    }

    :global(.search-button) {
        height: 50px;
    }

    .form-wrapper {
        display: flex;
        justify-content: space-evenly;
        gap: 5px;
    }

    .form-wrapper button {
        height: 30px !important;
    }

    @media screen and (max-width: 900px) {
        .form-wrapper {
            flex-direction: column;
            gap: 2px;
            height: auto;
        }
    }

    .row {
        flex: 1;
        overflow: hidden;
    }

    .input-wrapper {
        position: relative;
        border: 1px solid grey;
        height: 50px;
        background-color: white;
    }

    .input-wrapper.select:before {
        position: absolute;
        top: -2px;
        right: -2px;
        width: 50px;
        height: 55px;
        padding: 0;
        content: '';
        background-image: url('../icons/icon_search_btn.svg');
        background-repeat: no-repeat;
        background-size: cover;
        pointer-events: none;
        background-position: center -5px;
    }

    .input-field {
        height: 100%;
        line-height: 51px;
        padding: 0 20px;
        outline: none;
        font-size: 15px;
        color: #808080;
        max-width: 100%;
        width: 100%;
        box-sizing: border-box;
        display: block;
        background-color: #fff;
        border: none;
        height: 100%;
        /*box-shadow: 0 1px 3px 0px rgb(0 0 0 / 6%);*/
        font-weight: 500;
        opacity: 1;
        border-radius: 3px;
    }


    .icon {
        background-repeat: no-repeat;
        background-position: 10px center;
        background-size: 20px;
        padding-left: 40px;
    }

    .category {
        background-image: url('../icons/category.png');
    }

    .price {
        background-image: url('../icons/price.png');
    }

    .keyword {
        background-image: url('../icons/keyword.png');
    }

</style>